import './ContactPage.css';

export default function ContactPage() {
  return (
    <div className="contact-container">
      <h1> Contact Us</h1>
      <p>
        We're here to help! If you have any questions about our kits, classes, or orders,
        feel free to reach out:
      </p>

      <div className="contact-info">
        <p><strong>Email:</strong> support@chronotechrobotics.com</p>
        <p><strong>Phone:</strong> Please send us an email for a phone contact.</p>
        <p><strong>Response Time:</strong> We will try to respond within 48 hours (Monday–Friday).</p>
        <p><strong>Phone Hours:</strong> 9 AM - 4 PM Pacific Time (Monday–Friday).</p>
      </div>

      <p className="note">
        For faster help, include your order information (if available) when contacting us.
      </p>
    </div>
  );
}
